import React, { useEffect, useState } from "react";
import _ from "lodash";
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table";
import { useLocation } from "react-router";
import GetAppIcon from "@material-ui/icons/GetApp";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {
  createStyles,
  Grid,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import {
  HeaderCellSort,
  useSort,
} from "@table-library/react-table-library/sort";
import "jspdf-autotable";
import { Icon } from "@iconify/react";

import { CustomTheme } from "../../../../types/customTheme";
import CardCommon from "../../../../components/card/CardCommon";
import MenuButtonCommon from "../../../../components/buttons/MenuButtonCommon";
import { handleDownloadCsv } from "./convertPdfExcel/convertDataToExcel";
import { handleDownloadPdf } from "./convertPdfExcel/convertDataToPdf";
import {
  sortDatesTime,
  sortNumbers,
  sortStrings,
} from "../../../../utils/commonArrayMap";
import LocationDetailsCard from "../../../../components/common/LocationDetailsCard";
import { getLocalStore } from "../../../../utils/store/localStore";
import { convertDateTimeFormat } from "../../../../utils/ConvertDateTimeFormat";

export interface PaymentReportInfoNodeProps {
  rewardRedeemedNodeList: any;
  locationSelectorList: any;
  filterDetails: any;
  filterData: any;
  basedOnShift: any;
  locationSelectedList: any;
  handleOnClickText: any;
  menuProducts: any;
  rewardNode: any;
}

const useStyles = (nodesLength: number, bodyLength: number) =>
  makeStyles((theme: CustomTheme) =>
    createStyles({
      startTextStyle: {
        fontWeight: "bold",
        display: "flex",
        justifyContent: "start",
        paddingLeft: "16px",
        fontSize: "12px",
      },
      hiddenScroll: {
        // 1. For Webkit (Chrome, Safari, Edge)
        "&::-webkit-scrollbar": {
          height: "1px", // Set a smaller height for the horizontal scrollbar (e.g., 5px)
          backgroundColor: "transparent", // Make the track background transparent
        },

        // Style the actual draggable part (the thumb)
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0, 0, 0, 0.3)", // Subtle dark color for the thumb
          borderRadius: 1, // Make the thumb rounded
        },

        // 2. For Firefox
        scrollbarWidth: "thin", // Makes the scrollbar less intrusive
        // This defines the color of the thumb (first value) and the track (second value)
        scrollbarColor: `${theme.palette.background.entity_highlight_background_current_footer} transparent`,
      },
      textStyleHeader: {
        display: "flex",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "12px",
      },
      endTextStyle: {
        display: "flex",
        justifyContent: "end",
        alignItems: "center",

        fontSize: "12px",
        paddingRight: "20px",
      },
      headerEndTextStyle: {
        display: "flex",
        justifyContent: "end",
        fontWeight: "bold",
        fontSize: "12px",
        paddingRight: "16px",
      },
      textStyle: {
        display: "flex",
        justifyContent: "center",
        fontSize: "12px",
      },
      headerStyle: {
        "&:last-of-type": {
          backgroundColor: theme.palette.background.table_header_background,
          color: theme.palette.custom.orange.contrastText,
        },
      },
      finalTotalRow: {
        cursor: "pointer",
        height: "40px",
        [`&:nth-of-type(${bodyLength + 1})`]: {
          color: theme.palette.custom["green"].contrastText,
          backgroundColor: theme.palette.custom.green.main,
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: theme.palette.custom.green.light,
          },
        },
      },
      totalRow: {
        cursor: "pointer",
        "&.css-16gtl2w": {
          display: "flex",
          justifyContent: "center",
        },
        "&:nth-of-type(n)": {
          color: theme.palette.custom["green"].contrastText,
          backgroundColor: theme.palette.custom.green.main,
          "&:hover": {
            backgroundColor: theme.palette.custom.green.light,
          },
        },
      },
      headerRow: {
        fontSize: "13px",
        cursor: "pointer",
        "&.css-16gtl2w": {
          display: "flex",
          justifyContent: "center",
        },
        "&:nth-of-type(odd)": {
          backgroundColor: theme.palette.background.paper,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
        "&:nth-of-type(even)": {
          backgroundColor: theme.palette.background.entity_background,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
      baseCellRow: {
        placeItems: "center",
        "& .css-16gtl2w": {
          fontWeight: "bold",
        },
        height: "40px",
        "&:nth-of-type(1)": {
          left: "0px",
          minWidth: `${100 / 6}%`,
          width: `${100 / 6}%`,
        },
        [theme.breakpoints.down("xl")]: {
          [`&:nth-of-type(n+2):nth-of-type(-n+${5})`]: {
            minWidth: `${100 / 6}%`,
            width: `${100 / 6}%`,
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "center",
              fontWeight: "bold",
            },
          },
          [`&:nth-of-type(${6})`]: {
            minWidth: `${100 / 6}%`,
            width: `${100 / 6}%`,
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "end",
              fontWeight: "bold",
              paddingRight: "16px",
            },
          },
        },
        [theme.breakpoints.down("lg")]: {
          [`&:nth-of-type(n+2):nth-of-type(-n+${5})`]: {
            minWidth: `20%`,
            width: `20%`,
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "center",
              fontWeight: "bold",
            },
          },
          [`&:nth-of-type(${6})`]: {
            minWidth: `20%`,
            width: `20%`,
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "end",
              fontWeight: "bold",
              paddingRight: "16px",
            },
          },
          "&:nth-of-type(1)": {
            left: "0px",
            minWidth: "20%",
            width: "20%",
          },
        },
        [theme.breakpoints.down("xs")]: {
          [`&:nth-of-type(n+2):nth-of-type(-n+${5})`]: {
            minWidth: "20%",
            width: "20%",
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "center",
              fontWeight: "bold",
            },
          },
          [`&:nth-of-type(${6})`]: {
            minWidth: "20%",
            width: "20%",
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "end",
              fontWeight: "bold",
              paddingRight: "16px",
            },
          },
          "&:nth-of-type(1)": {
            left: "0px",
            minWidth: "20%",
            width: "20%",
          },
        },
      },
    }),
  );

/**
 * PaymentReportInfoNode Component
 *
 * This component renders a table displaying payment report data.
 * It also provides options to export the report as PDF or CSV.
 * Users can view sale details by clicking on items in the table.
 */
const PaymentReportInfoNode: React.FunctionComponent<
  PaymentReportInfoNodeProps
> = ({
  rewardRedeemedNodeList,
  locationSelectorList,
  filterDetails,
  filterData,
  basedOnShift,
  locationSelectedList,
  handleOnClickText,
  menuProducts,
  rewardNode,
}) => {
  const [pdfHeaders, setPdfHeaders] = useState<any>([]);
  const [headersList, setHeadersList] = useState<any>([]);
  const [excelHeaders, setExcelHeaders] = useState<any>([]);
  const [nodes, setNodes] = useState<any>({ nodes: [] });
  const [nodesNew, setNodesNew] = useState<any>({});
  const [nodesPdfExcel, setNodesPdfExcel] = useState<any>([]);
  const [footer, setFooter] = useState<any>([]);
  const [nodesLength, setNodeLength] = useState(0);
  const [bodyLength, setBodyLength] = useState(0);
  const [locationsLength, setLocationsLength] = useState(0);
  const [openSaleDetailsModal, setOpenSaleDetailsModal] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [cloneFilterData, setCloneFilterData] = useState("");

  const maxWidth = useMediaQuery("(max-width: 1500px)");
  const maxWidthCustom = useMediaQuery("(max-width: 1500px)");
  const open = Boolean(anchorEl);
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  useEffect(() => {
    setNodes({ nodes: [] });
  }, [params.get("startDate")]);

  // const rewardNod = {
  //   "321f81d2-694a-4d7d-8cd2-6cf7ab9e7fa8": {
  //     description: "Collect 5 stamps and enjoy a free standard drink",
  //     id: "321f81d2-694a-4d7d-8cd2-6cf7ab9e7fa8",
  //     img: "https://res.cloudinary.com/presto-blue-sakura/image/upload/t_presto_thumb/v1722878905/YOH%20BURGER/YOH%2005.08.2024/Drinks%20and%20Shakes/Pepsi_fuw7r8.jpg",
  //     is_points_reset: false,
  //     max_reward_value: "0.00",
  //     title: "Enjoy a free standard drink",
  //     type: "product",
  //     units_to_redeem: "4.00",
  //     products: {
  //       "919": {
  //         id: 919,
  //         include_meal: false,
  //         include_modifiers: false,
  //         surcharge: "0.50",
  //       },
  //       "920": {
  //         id: 920,
  //         include_meal: false,
  //         include_modifiers: true,
  //         surcharge: "0.00",
  //       },
  //       "924": {
  //         id: 924,
  //         include_meal: false,
  //         include_modifiers: false,
  //         surcharge: "0.00",
  //       },
  //     },
  //   },
  //   "5526c4a9-8868-4742-ac5f-86e220c0afcb": {
  //     description: "Collect 10 stamps to grab a free fries.",
  //     id: "5526c4a9-8868-4742-ac5f-86e220c0afcb",
  //     img: "https://res.cloudinary.com/presto-blue-sakura/image/upload/t_presto_cover/v1723275238/YOH%20BURGER/10.08.2024/FRIES_kph2ef.jpg",
  //     is_points_reset: false,
  //     max_reward_value: "4.00",
  //     title: "Grab a free side or fries",
  //     type: "product",
  //     units_to_redeem: "6.00",
  //     products: {
  //       "919": {
  //         id: 919,
  //         include_meal: false,
  //         include_modifiers: false,
  //         surcharge: "0.00",
  //       },
  //       "998": {
  //         id: 998,
  //         include_meal: false,
  //         include_modifiers: false,
  //         surcharge: "0.00",
  //       },
  //       "1003": {
  //         id: 1003,
  //         include_meal: false,
  //         include_modifiers: false,
  //         surcharge: "0.00",
  //       },
  //     },
  //   },
  //   "fc669410-ca2a-49ef-93ac-b33db503dbca": {
  //     description:
  //       "With 15 stamps, indulge in a free Yoh chicken burger or use £6.95 off towards other burgers.",
  //     id: "fc669410-ca2a-49ef-93ac-b33db503dbca",
  //     img: "https://res.cloudinary.com/presto-blue-sakura/image/upload/t_presto_thumb/v1722878767/YOH%20BURGER/YOH%2005.08.2024/Grill%20Chicken%20Burgers/Grilled_Peri_Chicken_Burger_ikt3eq.jpg",
  //     is_points_reset: false,
  //     max_reward_value: "0.00",
  //     title: "Indulge in a free main dish",
  //     type: "product",
  //     units_to_redeem: "10.00",
  //     products: {
  //       "1160": {
  //         id: 1160,
  //         include_meal: true,
  //         include_modifiers: false,
  //         surcharge: "2.00",
  //       },
  //       "1161": {
  //         id: 1161,
  //         include_meal: false,
  //         include_modifiers: false,
  //         surcharge: "0.00",
  //       },
  //     },
  //   },
  // };

  // const rewardRedeemedNodeLis = [
  //   {
  //     rewardId: "321f81d2-694a-4d7d-8cd2-6cf7ab9e7fa8",
  //     chosenItemId: "920",
  //     timesChosen: 2,
  //     uniqueCustomers: 2,
  //     totalRewardCost: 7.98,
  //     totalSpendAmount: 0.0,
  //     firstChosen: "2025-09-29T14:16:40.000+00:00",
  //     lastChosen: "2025-09-30T07:44:40.000+00:00",
  //   },
  //   {
  //     rewardId: "fc669410-ca2a-49ef-93ac-b33db503dbca",
  //     chosenItemId: "1543",
  //     timesChosen: 1,
  //     uniqueCustomers: 1,
  //     totalRewardCost: 3.99,
  //     totalSpendAmount: 6.0,
  //     firstChosen: "2025-10-15T12:03:05.000+00:00",
  //     lastChosen: "2025-10-15T12:03:05.000+00:00",
  //   },
  //   {
  //     rewardId: "fc669410-ca2a-49ef-93ac-b33db503dbca",
  //     chosenItemId: "1160",
  //     timesChosen: 1,
  //     uniqueCustomers: 1,
  //     totalRewardCost: 4.99,
  //     totalSpendAmount: 3.49,
  //     firstChosen: "2025-09-30T06:00:02.000+00:00",
  //     lastChosen: "2025-09-30T06:00:02.000+00:00",
  //   },
  // ];
  // const menuNode = {
  //   "919": {
  //     id: "919",
  //     name: "Peroni Nastro Azzurro",
  //   },
  //   "920": {
  //     id: "920",
  //     name: "Per",
  //   },
  //   "924": {
  //     id: "924",
  //     name: "Pepsi Zero 330ml",
  //   },
  //   "998": {
  //     id: "998",
  //     name: "Peroni Nastro",
  //   },
  //   "1003": {
  //     id: "1003",
  //     name: "Pepsi 330ml",
  //   }
  // };
  // const cloneRewardRedeemedNodeList = {
  //   "321f81d2-694a-4d7d-8cd2-6cf7ab9e7fa8": {
  //     body: [
  //       {
  //         chosenItemId: "Peroni Nastro Azzurro",
  //         firstChosen: "-",
  //         lastChosen: "-",
  //         rewardId: "Enjoy a free standard drink",
  //         timesChosen: 0,
  //         totalRewardCost: 0,
  //         totalSpendAmount: 0,
  //         uniqueCustomers: 0,
  //       },
  //       {
  //         chosenItemId: "Per",
  //         firstChosen: "Sep 29,  2025    19:46",
  //         lastChosen: "Sep 30,  2025    13:14",
  //         rewardId: "Enjoy a free standard drink",
  //         timesChosen: 2,
  //         totalRewardCost: 7.98,
  //         totalSpendAmount: 0,
  //         uniqueCustomers: 2,
  //       },
  //       {
  //         chosenItemId: "Pepsi Zero 330ml",
  //         firstChosen: "-",
  //         lastChosen: "-",
  //         rewardId: "Enjoy a free standard drink",
  //         timesChosen: 0,
  //         totalRewardCost: 0,
  //         totalSpendAmount: 0,
  //         uniqueCustomers: 0,
  //       },
  //     ],
  //     footer: {
  //       chosenItemId: "Total",
  //       firstChosen: "",
  //       lastChosen: "",
  //       rewardId: "",
  //       timesChosen: 2,
  //       totalRewardCost: 7.98,
  //       uniqueCustomers: 2,
  //     },
  //     name: "Enjoy a free standard drink",
  //   },
  //   "5526c4a9-8868-4742-ac5f-86e220c0afcb": {
  //     body: [
  //       {
  //         chosenItemId: "Peroni Nastro Azzurro",
  //         firstChosen: "-",
  //         lastChosen: "-",
  //         rewardId: "Grab a free side or fries",
  //         timesChosen: 0,
  //         totalRewardCost: 0,
  //         totalSpendAmount: 0,
  //         uniqueCustomers: 0,
  //       },
  //       {
  //         chosenItemId: "Peroni Nastro",
  //         firstChosen: "-",
  //         lastChosen: "-",
  //         rewardId: "Grab a free side or fries",
  //         timesChosen: 0,
  //         totalRewardCost: 0,
  //         totalSpendAmount: 0,
  //         uniqueCustomers: 0,
  //       },
  //       {
  //         chosenItemId: "Pepsi 330ml",
  //         firstChosen: "-",
  //         lastChosen: "-",
  //         rewardId: "Grab a free side or fries",
  //         timesChosen: 0,
  //         totalRewardCost: 0,
  //         totalSpendAmount: 0,
  //         uniqueCustomers: 0,
  //       },
  //     ],
  //     footer: {
  //       chosenItemId: "Total",
  //       firstChosen: "",
  //       lastChosen: "",
  //       rewardId: "",
  //       timesChosen: 0,
  //       totalRewardCost: 0,
  //       uniqueCustomers: 0,
  //     },
  //     name: "Grab a free side or fries",
  //   },
  //   "fc669410-ca2a-49ef-93ac-b33db503dbca": {
  //     body: [
  //       {
  //         chosenItemId: "1160",
  //         firstChosen: "Oct 15,  2025    17:33",
  //         lastChosen: "Oct 15,  2025    17:33",
  //         rewardId: "Indulge in a free main dish",
  //         timesChosen: 1,
  //         totalRewardCost: 3.99,
  //         totalSpendAmount: 6,
  //         uniqueCustomers: 1,
  //       },
  //       {
  //         chosenItemId: "1161",
  //         firstChosen: "-",
  //         lastChosen: "-",
  //         rewardId: "Indulge in a free main dish",
  //         timesChosen: 0,
  //         totalRewardCost: 0,
  //         totalSpendAmount: 0,
  //         uniqueCustomers: 0,
  //       },
  //     ],
  //     footer: {
  //       chosenItemId: "Total",
  //       firstChosen: "",
  //       lastChosen: "",
  //       rewardId: "",
  //       timesChosen: 2,
  //       totalRewardCost: 8.98,
  //       uniqueCustomers: 2,
  //     },
  //     name: "Indulge in a free main dish",
  //   },
  // };

  interface RawItem {
    rewardId: string;
    rewardName: string;
    chosenItemId: string;
    firstChosen: string | "-";
    lastChosen: string | "-";
    timesChosen: number;
    totalRewardCost: number;
    totalSpendAmount: number;
    uniqueCustomers: number;
  }

  const rewardNod = {
    "321f81d2-694a-4d7d-8cd2-6cf7ab9e7fa8": {
      description: "Collect 5 stamps and enjoy a free standard drink",
      id: "321f81d2-694a-4d7d-8cd2-6cf7ab9e7fa8",
      img: "https://res.cloudinary.com/presto-blue-sakura/image/upload/t_presto_thumb/v1722878905/YOH%20BURGER/YOH%2005.08.2024/Drinks%20and%20Shakes/Pepsi_fuw7r8.jpg",
      is_points_reset: false,
      max_reward_value: "0.00",
      title: "Enjoy a free standard drink",
      type: "product",
      units_to_redeem: "4.00",
      products: {
        "919": {
          id: 919,
          include_meal: false,
          include_modifiers: false,
          surcharge: "0.50",
        },
        "920": {
          id: 920,
          include_meal: false,
          include_modifiers: true,
          surcharge: "0.00",
        },
        "924": {
          id: 924,
          include_meal: false,
          include_modifiers: false,
          surcharge: "0.00",
        },
      },
    },
    "5526c4a9-8868-4742-ac5f-86e220c0afcb": {
      description: "Collect 10 stamps to grab a free fries.",
      id: "5526c4a9-8868-4742-ac5f-86e220c0afcb",
      img: "https://res.cloudinary.com/presto-blue-sakura/image/upload/t_presto_cover/v1723275238/YOH%20BURGER/10.08.2024/FRIES_kph2ef.jpg",
      is_points_reset: false,
      max_reward_value: "4.00",
      title: "Grab a free side or fries",
      type: "product",
      units_to_redeem: "6.00",
      products: {
        "919": {
          id: 919,
          include_meal: false,
          include_modifiers: false,
          surcharge: "0.00",
        },
        "998": {
          id: 998,
          include_meal: false,
          include_modifiers: false,
          surcharge: "0.00",
        },
        "1003": {
          id: 1003,
          include_meal: false,
          include_modifiers: false,
          surcharge: "0.00",
        },
      },
    },
    "fc669410-ca2a-49ef-93ac-b33db503dbca": {
      description:
        "With 15 stamps, indulge in a free Yoh chicken burger or use £6.95 off towards other burgers.",
      id: "fc669410-ca2a-49ef-93ac-b33db503dbca",
      img: "https://res.cloudinary.com/presto-blue-sakura/image/upload/t_presto_thumb/v1722878767/YOH%20BURGER/YOH%2005.08.2024/Grill%20Chicken%20Burgers/Grilled_Peri_Chicken_Burger_ikt3eq.jpg",
      is_points_reset: false,
      max_reward_value: "0.00",
      title: "Indulge in a free main dish",
      type: "product",
      units_to_redeem: "10.00",
      products: {
        "1160": {
          id: 1160,
          include_meal: true,
          include_modifiers: false,
          surcharge: "2.00",
        },
        "1161": {
          id: 1161,
          include_meal: false,
          include_modifiers: false,
          surcharge: "0.00",
        },
      },
    },
  };

  const rewardRedeemedNodeLis = [
    {
      rewardId: "321f81d2-694a-4d7d-8cd2-6cf7ab9e7fa8",
      chosenItemId: "920",
      timesChosen: 2,
      uniqueCustomers: 2,
      totalRewardCost: 7.98,
      totalSpendAmount: 0.0,
      firstChosen: "2025-09-29T14:16:40.000+00:00",
      lastChosen: "2025-09-30T07:44:40.000+00:00",
    },
    {
      rewardId: "fc669410-ca2a-49ef-93ac-b33db503dbca",
      chosenItemId: "1543",
      timesChosen: 1,
      uniqueCustomers: 1,
      totalRewardCost: 3.99,
      totalSpendAmount: 6.0,
      firstChosen: "2025-10-15T12:03:05.000+00:00",
      lastChosen: "2025-10-15T12:03:05.000+00:00",
    },
    {
      rewardId: "fc669410-ca2a-49ef-93ac-b33db503dbca",
      chosenItemId: "1160",
      timesChosen: 1,
      uniqueCustomers: 1,
      totalRewardCost: 4.99,
      totalSpendAmount: 3.49,
      firstChosen: "2025-09-30T06:00:02.000+00:00",
      lastChosen: "2025-09-30T06:00:02.000+00:00",
    },
  ];
  const menuNode = {
    "919": {
      id: "919",
      name: "Peroni Nastro Azzurro",
    },
    "920": {
      id: "920",
      name: "Per",
    },
    "924": {
      id: "924",
      name: "Pepsi Zero 330ml",
    },
    "998": {
      id: "998",
      name: "Peroni Nastro",
    },
    "1003": {
      id: "1003",
      name: "Pepsi 330ml",
    },
  };
  const cloneRewardRedeemedNodeList = {
    "321f81d2-694a-4d7d-8cd2-6cf7ab9e7fa8": {
      body: [
        {
          chosenItemId: "Peroni Nastro Azzurro",
          firstChosen: "-",
          lastChosen: "-",
          rewardId: "Enjoy a free standard drink",
          timesChosen: 0,
          totalRewardCost: 0,
          totalSpendAmount: 0,
          uniqueCustomers: 0,
        },
        {
          chosenItemId: "Per",
          firstChosen: "Sep 29,  2025    19:46",
          lastChosen: "Sep 30,  2025    13:14",
          rewardId: "Enjoy a free standard drink",
          timesChosen: 2,
          totalRewardCost: 7.98,
          totalSpendAmount: 0,
          uniqueCustomers: 2,
        },
        {
          chosenItemId: "Pepsi Zero 330ml",
          firstChosen: "-",
          lastChosen: "-",
          rewardId: "Enjoy a free standard drink",
          timesChosen: 0,
          totalRewardCost: 0,
          totalSpendAmount: 0,
          uniqueCustomers: 0,
        },
      ],
      footer: {
        chosenItemId: "Total",
        firstChosen: "",
        lastChosen: "",
        rewardId: "",
        timesChosen: 2,
        totalRewardCost: 7.98,
        uniqueCustomers: 2,
      },
      name: "Enjoy a free standard drink",
    },
    "5526c4a9-8868-4742-ac5f-86e220c0afcb": {
      body: [
        {
          chosenItemId: "Peroni Nastro Azzurro",
          firstChosen: "-",
          lastChosen: "-",
          rewardId: "Grab a free side or fries",
          timesChosen: 0,
          totalRewardCost: 0,
          totalSpendAmount: 0,
          uniqueCustomers: 0,
        },
        {
          chosenItemId: "Peroni Nastro",
          firstChosen: "-",
          lastChosen: "-",
          rewardId: "Grab a free side or fries",
          timesChosen: 0,
          totalRewardCost: 0,
          totalSpendAmount: 0,
          uniqueCustomers: 0,
        },
        {
          chosenItemId: "Pepsi 330ml",
          firstChosen: "-",
          lastChosen: "-",
          rewardId: "Grab a free side or fries",
          timesChosen: 0,
          totalRewardCost: 0,
          totalSpendAmount: 0,
          uniqueCustomers: 0,
        },
      ],
      footer: {
        chosenItemId: "Total",
        firstChosen: "",
        lastChosen: "",
        rewardId: "",
        timesChosen: 0,
        totalRewardCost: 0,
        uniqueCustomers: 0,
      },
      name: "Grab a free side or fries",
    },
    "fc669410-ca2a-49ef-93ac-b33db503dbca": {
      body: [
        {
          chosenItemId: "1160",
          firstChosen: "Oct 15,  2025    17:33",
          lastChosen: "Oct 15,  2025    17:33",
          rewardId: "Indulge in a free main dish",
          timesChosen: 1,
          totalRewardCost: 3.99,
          totalSpendAmount: 6,
          uniqueCustomers: 1,
        },
        {
          chosenItemId: "1161",
          firstChosen: "-",
          lastChosen: "-",
          rewardId: "Indulge in a free main dish",
          timesChosen: 0,
          totalRewardCost: 0,
          totalSpendAmount: 0,
          uniqueCustomers: 0,
        },
      ],
      footer: {
        chosenItemId: "Total",
        firstChosen: "",
        lastChosen: "",
        rewardId: "",
        timesChosen: 2,
        totalRewardCost: 8.98,
        uniqueCustomers: 2,
      },
      name: "Indulge in a free main dish",
    },
  };

  /* Creating the data for the Payment report table and creating the data for pdf and excel files.
       Using a API request */
  useEffect(() => {
    if (_.isEmpty(rewardRedeemedNodeList)) return;

    // ✅ Deep clone to avoid mutating props/state
    const cloneRewardRedeemedNodeList: any = _.cloneDeep(
      rewardRedeemedNodeList,
    );

    // ✅ Build the reward order list based on rewardNode keys (to preserve defined order)
    const rewardOrder = Object.keys(rewardNode);

    // ✅ Ensure all rewards exist in the clone list (even if 0 values)
    rewardOrder.forEach((rewardId) => {
      const exists = cloneRewardRedeemedNodeList.some(
        (item: any) => item.rewardId === rewardId,
      );
      if (!exists) {
        cloneRewardRedeemedNodeList.push({
          rewardId,
          timesRedeemed: 0,
          totalRewardCost: 0,
          uniqueCustomersRedeemed: 0,
          firstRedemption: "-",
          lastRedemption: "-",
        });
      }
    });

    function generateRewardOutput(input: any, input1: any, input3: any) {
      const output: any = {};

      for (const [rewardId, rewardData] of Object.entries(input)) {
        const { title, products }: any = rewardData;
        const body = [];

        let totalTimesChosen = 0;
        let totalRewardCost = 0;
        let totalSpendAmount = 0;
        let totalUniqueCustomers = 0;

        // iterate products
        for (const [productId, productObj] of Object.entries(products)) {
          const items = input3[productId] || [];

          for (const item of items) {
            const matchingReward = input1.find(
              (r: any) =>
                r.rewardId === rewardId &&
                r.chosenItemId === item.id.toString(),
            );

            if (matchingReward) {
              body.push({
                chosenItemId: item.name,
                firstChosen: convertDateTimeFormat(matchingReward.firstChosen),
                lastChosen: convertDateTimeFormat(matchingReward.lastChosen),
                rewardId: title,
                timesChosen: matchingReward.timesChosen,
                totalRewardCost: matchingReward.totalRewardCost,
                totalSpendAmount: matchingReward.totalSpendAmount,
                uniqueCustomers: matchingReward.uniqueCustomers,
              });

              totalTimesChosen += matchingReward.timesChosen;
              totalRewardCost += matchingReward.totalRewardCost;
              totalSpendAmount += matchingReward.totalSpendAmount;
              totalUniqueCustomers += matchingReward.uniqueCustomers;
            } else {
              body.push({
                chosenItemId: item.name,
                firstChosen: "-",
                lastChosen: "-",
                rewardId: title,
                timesChosen: 0,
                totalRewardCost: 0,
                totalSpendAmount: 0,
                uniqueCustomers: 0,
              });
            }
          }
        }

        output[rewardId] = {
          body,
          footer: {
            chosenItemId: "Total",
            firstChosen: "",
            lastChosen: "",
            rewardId: "",
            timesChosen: totalTimesChosen,
            totalRewardCost: parseFloat(totalRewardCost.toString()).toFixed(2),
            uniqueCustomers: totalUniqueCustomers,
          },
          name: title,
        };
      }

      return output;
    }

    // Convert reward object into sorted array based on units_to_redeem
    const sortRewardsByUnitsToRedeem = (rewardObject: any) => {
      // 1. Get the keys (Reward IDs) as an array.
      const keys = Object.keys(rewardObject);

      // 2. Sort the keys based on the units_to_redeem value of their corresponding object.
      keys.sort((a, b) => {
        const unitsA = parseFloat(rewardObject[a].units_to_redeem);
        const unitsB = parseFloat(rewardObject[b].units_to_redeem);
        // Sort in ascending order (smallest units_to_redeem first)
        return unitsA - unitsB;
      });

      // 3. Reconstruct the object using the sorted keys.
      const sortedRewards: any = {};
      for (const key of keys) {
        sortedRewards[key] = rewardObject[key];
      }

      return sortedRewards;
    };

    const sortedRewards = sortRewardsByUnitsToRedeem(rewardNode);

    // Example usage:
    const finalOutput = generateRewardOutput(
      sortedRewards,
      rewardRedeemedNodeList,
      menuProducts,
    );

    // ✅ Debug output

    // ✅ Set into state for table/pdf/excel
    setNodesNew(finalOutput);

    // Set headers
    const commonHeaders = [
      { title: "Product Name", field: "chosenItemId" },
      { title: "Times Chosen", field: "timesChosen" },
      { title: "Total Reward Cost", field: "totalRewardCost" },
      { title: "Unique Customers", field: "uniqueCustomers" },
      { title: "First Redeemed", field: "firstChosen" },
      { title: "Last Redeemed", field: "lastChosen" },
    ];

    setPdfHeaders(commonHeaders);
    setHeadersList(commonHeaders.map((h) => h.title));

    setExcelHeaders(
      commonHeaders.map((h) => ({
        header: h.title,
        key: h.field,
        width: 32,
        height: 68,
      })),
    );

    // ✅ Calculate overall footer (all rewards combined)
    const overallFooter: any = Object.values(finalOutput).reduce(
      (acc: any, reward: any) => {
        acc.timesChosen += reward.footer.timesChosen;
        acc.totalRewardCost += reward.footer.totalRewardCost;
        acc.uniqueCustomers += reward.footer.uniqueCustomers;
        return acc;
      },
      {
        rewardId: "Total",
        timesChosen: 0,
        totalRewardCost: 0,
        uniqueCustomers: 0,
        firstChosen: "",
        lastChosen: "",
      },
    );

    overallFooter.totalRewardCost = parseFloat(
      overallFooter.totalRewardCost,
    ).toFixed(2);

    // ✅ Count rows
    setNodeLength(cloneRewardRedeemedNodeList.length - 1);
    setBodyLength(cloneRewardRedeemedNodeList.length);

    // ✅ Flattened list for table/pdf/excel
    const mergedForExport = cloneRewardRedeemedNodeList.map((d: any) => ({
      ...d,
      chosenItemId: menuProducts[d?.chosenItemId]?.name || "",
    }));

    const exportData = [...mergedForExport, overallFooter];

    setFooter(overallFooter);
    setNodes({ nodes: mergedForExport });
    setNodesPdfExcel(exportData);
  }, [rewardRedeemedNodeList, menuProducts, rewardNode]);

  // Create a pay In Out sorting function
  const sort = useSort(
    nodes,
    {},
    {
      sortFns: {
        "First Redeemed": (array) => sortDatesTime(array, "firstChosen"),
        "Last Redeemed": (array) => sortDatesTime(array, "lastChosen"),
        "Product Name": (array) => sortStrings(array, "chosenItemId"),
        "Times Chosen": (array) => sortNumbers(array, "timesChosen"),
        "Total Reward Cost": (array) => sortNumbers(array, "totalRewardCost"),
        "Unique Customers": (array) => sortNumbers(array, "uniqueCustomers"),
      },
      sortIcon: {
        margin: "0px",
        iconDefault: (
          <Icon
            icon="fluent:chevron-up-down-16-filled"
            width="44"
            height="44"
          />
        ),
        iconUp: <ArrowDropDownIcon />,
        iconDown: <ArrowDropUpIcon />,
      },
    },
  );

  /* Open PDF / Excel selection menu */
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  /* Close PDF / Excel selection menu */
  const handleClose = () => {
    setAnchorEl(null);
  };

  const maxWidthLocationChips = useMediaQuery("(max-width: 600px)");
  const theme: CustomTheme = useTheme();
  const classes: any = useStyles(nodesLength, bodyLength)();

  return (
    <>
      <Grid
        container
        style={{
          marginBottom: "20px",
          marginTop: "8px",
        }}
      >
        <Grid item xs={12}>
          <div
            style={
              maxWidthLocationChips
                ? { display: "block" }
                : {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }
            }
          >
            <LocationDetailsCard
              locationSelectedList={locationSelectedList}
              handleOnClickText={handleOnClickText}
            />
            {!_.isEmpty(nodes.nodes) && (
              <div
                style={
                  maxWidthLocationChips
                    ? {
                        display: "flex",
                        justifyContent: "end",
                        marginTop: "8px",
                      }
                    : { marginLeft: "16px" }
                }
              >
                <MenuButtonCommon
                  id="basic-button"
                  variant="contained"
                  style={{
                    fontSize: 11,
                    height: "38px",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                  }}
                  color="blue"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <GetAppIcon />
                  <Typography
                    variant="body1"
                    style={{ paddingLeft: "16px", color: "white" }}
                  >
                    Export
                  </Typography>
                </MenuButtonCommon>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  PaperProps={{
                    elevation: 0,
                    style: {
                      borderRadius: "10px",
                      border: `1px solid ${theme.palette.background.entity_border}`,
                    },
                  }}
                  style={{ top: "56px" }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      handleDownloadPdf(filterDetails, pdfHeaders, nodesNew);
                      handleClose();
                    }}
                  >
                    Export as PDF
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleDownloadCsv(excelHeaders, nodesNew, filterDetails);
                      handleClose();
                    }}
                  >
                    Export as CSV
                  </MenuItem>
                </Menu>
              </div>
            )}
          </div>
        </Grid>
      </Grid>
      {Object.entries(nodesNew).map(([rewardId, rewardData]: any) => {
        const { name, body, footer } = rewardData;
        return (
          <>
            <Typography
              style={{
                marginTop: "32px",
                fontWeight: "bold",
              }}
              variant="h6"
              align="left"
            >
              {name}
            </Typography>
            <Typography
              style={{
                marginBottom: "8px",
                display: "flex",
                justifyContent: "start",
              }}
              variant="caption"
              align="left"
            >
              Note: This report is generated for the selected location only, as
              reward item selections may differ across locations.
            </Typography>
            <CardCommon>
              <Table
                data={{ nodes: body }}
                sort={sort}
                layout={{ custom: maxWidthCustom, horizontalScroll: maxWidth }}
                className={classes.hiddenScroll}
              >
                {(tableList) => (
                  <>
                    <Header style={{ zIndex: 0 }}>
                      <HeaderRow className={classes.headerStyle}>
                        {headersList.map(
                          (data: any, index: any) =>
                            data !== "rewardId" && (
                              <HeaderCellSort
                                sortKey={data}
                                pinLeft={index === 0 ? true : false}
                                className={classes.baseCellRow}
                                style={{ paddingRight: "4px" }}
                              >
                                <Typography
                                  variant="caption"
                                  className={
                                    index === 0
                                      ? classes.startTextStyle
                                      : index === 5
                                      ? classes.headerEndTextStyle
                                      : classes.textStyleHeader
                                  }
                                  style={{
                                    color:
                                      theme.palette.custom.orange.contrastText,
                                  }}
                                >
                                  {data}
                                </Typography>
                              </HeaderCellSort>
                            ),
                        )}
                      </HeaderRow>
                    </Header>

                    <Body className={classes.bodyStyle}>
                      {tableList.map((item, bodyIndex) => (
                        <>
                          <Row
                            key={item.gross20}
                            item={item}
                            className={
                              item.Method === "Total Payments"
                                ? classes.totalRow
                                : classes.headerRow
                            }
                          >
                            <Cell
                              pinLeft={true}
                              className={classes.baseCellRow}
                            >
                              <Typography
                                variant="caption"
                                align="left"
                                className={classes.startTextStyle}
                              >
                                {item["chosenItemId"]}
                              </Typography>
                            </Cell>
                            <Cell
                              pinLeft={false}
                              className={classes.baseCellRow}
                            >
                              <Typography
                                variant="caption"
                                align="left"
                                className={classes.textStyle}
                              >
                                {item["timesChosen"]}
                              </Typography>
                            </Cell>
                            <Cell
                              pinLeft={false}
                              className={classes.baseCellRow}
                            >
                              <Typography
                                variant="caption"
                                align="left"
                                className={classes.textStyle}
                              >
                                {item["totalRewardCost"]}
                              </Typography>
                            </Cell>
                            <Cell
                              pinLeft={false}
                              className={classes.baseCellRow}
                            >
                              <Typography
                                variant="caption"
                                align="left"
                                className={classes.textStyle}
                              >
                                {item["uniqueCustomers"]}
                              </Typography>
                            </Cell>

                            <Cell
                              pinLeft={false}
                              className={classes.baseCellRow}
                            >
                              <Typography
                                variant="caption"
                                align="left"
                                className={classes.textStyle}
                              >
                                {item["firstChosen"]}
                              </Typography>
                            </Cell>
                            <Cell
                              pinLeft={false}
                              className={classes.baseCellRow}
                            >
                              <Typography
                                variant="caption"
                                align="left"
                                className={classes.endTextStyle}
                              >
                                {item["lastChosen"]}
                              </Typography>
                            </Cell>
                          </Row>
                          {bodyIndex + 1 === tableList.length && (
                            <>
                              <Row
                                className={classes.finalTotalRow}
                                key={footer.firstChosen}
                                item={footer}
                                style={{
                                  backgroundColor:
                                    bodyIndex + 1 === tableList.length
                                      ? theme.palette.custom.green.main
                                      : undefined,
                                  color:
                                    bodyIndex + 1 === tableList.length
                                      ? theme.palette.custom.green.contrastText
                                      : undefined,
                                  fontWeight:
                                    bodyIndex + 1 === tableList.length
                                      ? "bold"
                                      : undefined,
                                }}
                              >
                                <Cell
                                  pinLeft={true}
                                  className={classes.baseCellRow}
                                >
                                  <Typography
                                    variant="caption"
                                    style={{
                                      fontWeight: "bold",
                                      color: "white",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    className={classes.startTextStyle}
                                  >
                                    {footer["chosenItemId"]}
                                  </Typography>
                                </Cell>

                                <Cell
                                  pinLeft={false}
                                  className={classes.baseCellRow}
                                >
                                  <Typography
                                    variant="caption"
                                    style={{
                                      fontWeight: "bold",
                                      color: "white",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    className={classes.textStyle}
                                  >
                                    {footer["timesChosen"]}
                                  </Typography>
                                </Cell>

                                <Cell
                                  pinLeft={false}
                                  className={classes.baseCellRow}
                                >
                                  <Typography
                                    variant="caption"
                                    style={{
                                      fontWeight: "bold",
                                      color: "white",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    className={classes.textStyle}
                                  >
                                    {footer["totalRewardCost"]}
                                  </Typography>
                                </Cell>

                                <Cell
                                  pinLeft={false}
                                  className={classes.baseCellRow}
                                >
                                  <Typography
                                    variant="caption"
                                    style={{
                                      fontWeight: "bold",
                                      color: "white",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    className={classes.textStyle}
                                  >
                                    {footer["uniqueCustomers"]}
                                  </Typography>
                                </Cell>
                                <Cell
                                  pinLeft={false}
                                  className={classes.baseCellRow}
                                >
                                  <Typography
                                    variant="caption"
                                    style={{
                                      fontWeight: "bold",
                                      color: "white",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    className={classes.textStyle}
                                  >
                                    {footer["firstChosen"]}
                                  </Typography>
                                </Cell>

                                <Cell
                                  pinLeft={false}
                                  className={classes.baseCellRow}
                                >
                                  <Typography
                                    variant="caption"
                                    style={{
                                      fontWeight: "bold",
                                      color: "white",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    className={classes.endTextStyle}
                                  >
                                    {footer["lastChosen"]}
                                  </Typography>
                                </Cell>
                              </Row>
                            </>
                          )}
                        </>
                      ))}
                    </Body>
                  </>
                )}
              </Table>
            </CardCommon>
          </>
        );
      })}
    </>
  );
};

export default PaymentReportInfoNode;
